import { Injectable } from '@angular/core';
import { WindowService } from './window.service';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(private windowService: WindowService) {}

  public set(key: string, value: string): void {
    if (this.windowService.isBrowser) {
      window.localStorage[key] = value;
    }
  }

  public get(key: string, defaultValue?: string): string {
    if (this.windowService.isBrowser) {
      return window.localStorage[key] || defaultValue;
    } else {
      return '';
    }
  }

  public setObject(key: string, value: any): void {
    if (this.windowService.isBrowser) {
      window.localStorage[key] = JSON.stringify(value);
    }
  }

  public getObject(key: string): any {
    if (this.windowService.isBrowser) {
      return JSON.parse(window.localStorage[key] || null);
    }
  }

  public delete(key: string): any {
    if (this.windowService.isBrowser) {
      delete window.localStorage[key];
    }
  }
}
